<ng-container *ngIf="job?.jobKind?.isFlex && status">
  <ion-chip [color]="colorCode()">
    <ion-icon
      *ngIf="colorCode() === 'green-50'"
      name="checkmark"
    ></ion-icon>
    <ion-icon
      *ngIf="colorCode() === 'red-50'"
      name="alert-circle"
    ></ion-icon>
    <ion-label>{{ status | titlecase }}</ion-label>
  </ion-chip>
</ng-container>
<ng-container *ngIf="!job?.jobKind?.isFlex && getBadges(job) as badges">
  <ion-chip
    *ngFor="let badge of badges | keyvalue: noSorting"
    [color]="badge.value"
  >
    <ion-icon
      *ngIf="badge.value === 'green-50'"
      name="checkmark"
    ></ion-icon>
    <ion-icon
      *ngIf="badge.value === 'red-50'"
      name="alert-circle"
    ></ion-icon>
    <ion-label>{{ badge.key === 'Once-off' ? 'One-off' : badge.key }}</ion-label>
  </ion-chip>
</ng-container>
